import { Button, Colors } from '@mercator-gcp/grout';

const buttonStyle = {
  padding: '0',
  height: 'auto',
  color: Colors.Tangerine900,
  '&:focus': {
    color: Colors.Tangerine900,
  },
  '&:hover': {
    color: Colors.TextDefault,
  },
};

type Props = {
  onClick: () => void;
};

const ClearAllButton = ({ onClick }: Props) => {
  return (
    <Button variant="unstyled" sx={buttonStyle} onClick={onClick}>
      Clear all
    </Button>
  );
};

export default ClearAllButton;
